<template>
   <div class="customer-details-wrapper content-wrapper fluid pt-5 ">
      <NotFound v-if="!customerSlugPageData" />

      <div v-if="customerSlugPageData">
         <div class="banner">
            <div class="container container-1200">
               <div class="row">
                  <div class="col-9">
                     <a class="card-anchor" @click.prevent="goto('/customers')">
                        <i class="fc_keyboard_arrow_left" />Back to Customers</a
                     >
                     <h1 class="text-white">{{ customerSlugPageData.content[0].header }}</h1>
                  </div>
               </div>
            </div>
         </div>

         <div class="detail-info">
            <div class="container container-1200">
               <div class="row">
                  <div class="col-sm-12 col-md-8 col-lg-8">
                     <div class="resources ">
                        <div
                           class="detail-info-container"
                           v-html="markedRender(customerSlugPageData.content[0].longDescription)"
                        />
                     </div>
                  </div>

                  <div class="col-sm-12 col-md-4 col-lg-4">
                     <CustomerDetailsProfile :datasrc="customerSlugPageData.content[0]" />
                  </div>
                  <Share :subject="getTitle" :body="getMailBody" class="mt-3" />
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import { mapState } from 'vuex';
import CustomerDetailsProfile from '../../components/customer/CustomerDetailsProfile.vue';
import NotFound from '../NotFound.vue';
import metaGenerator from '../../util/meta.js';
import Share from '../../components/core/Share';

export default {
   components: {
      CustomerDetailsProfile,
      NotFound,
      Share,
   },

   computed: {
      ...mapState(['customerSlugPageData']),
      getMailBody() {
         return `Hi,\n\t I came upon this testimonial about FusionCharts. Thought will share it with you as you might find it useful - https://www.fusioncharts.com${this.$router.history.current.path}`;
      },
      getTitle() {
         return this.customerSlugPageData.meta.header;
      },
   },
   asyncData({ store, route }) {
      return Promise.all([
         store.dispatch('CUSTOMER_SLUG_PAGE_DATA_FETCH', {
            slug: route.params.slug,
         }),
      ]);
   },
   metaInfo() {
      return metaGenerator(this.customerSlugPageData);
   },
   methods: {
      goto(url) {
         url && this.$router.push(url).catch(() => {});
      },
   },
};
</script>

<style lang="scss">
.customer-details-wrapper {
   background-color: #f9f9fb;
   .banner {
      padding: 85px 0;
      background: linear-gradient(
         150.48deg,
         #22166a 0%,
         rgba(145, 64, 134, 0.99) 54.33%,
         #ecd4a0 100%
      );
      color: #ffffff;
      // p {
      //    span {
      //       position: relative;
      //       color: #ffffff;
      //       line-height: 28px;
      //       font-size: 14px;
      //       i {
      //          position: relative;
      //          top: 7px;
      //       }
      //    }
      // }
      h1 {
         line-height: 47px;
         margin: 0;
      }
   }

   .card-anchor {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      cursor: pointer;
      i {
         font-size: 20px;
      }
   }

   .detail-info {
      padding: 65px 0;
   }

   .detail-info-container {
      h2 {
         color: #212344;
         font-size: 26px;
         line-height: 33px;
      }
      p {
         margin-bottom: 35px;
      }
   }
}
</style>
